<script>
  import { _ } from '@sveltia/i18n';
  import { Icon, TreeItem } from '@sveltia/ui';

  import { announcedPageStatus, goto } from '$lib/services/app/navigation';
  import { encodePathSegments } from '$lib/services/utils/url';

  /**
   * @import { CollectionFile } from '$lib/types/public';
   */

  /**
   * @typedef {object} Props
   * @property {CollectionFile} file The singleton file to display.
   */

  /** @type {Props} */
  let {
    /* eslint-disable prefer-const */
    file,
    /* eslint-enable prefer-const */
  } = $props();

  const { name, icon } = $derived(file);
  const label = $derived(file.label || name);

  /** @type {boolean} */
  let selected = $state(false);
  /** @type {HTMLElement | undefined} */
  let wrapper = $state();
</script>

<div class="wrapper" bind:this={wrapper}>
  <TreeItem
    bind:selected
    {label}
    onSelect={() => {
      // Announce the selected singleton file. The Content Editor will not open until
      // the user presses Enter.
      announcedPageStatus.current = _('singleton_selected_announcement', {
        values: { file: label },
      });
    }}
    onclick={() => {
      goto(encodePathSegments(`/collections/_singletons/entries/${name}`), {
        transitionType: 'forwards',
      });
      // Reset the selected state and remove the focused class from the option
      // @todo Handle this in Sveltia UI
      selected = false;
      wrapper?.querySelector('[role="treeitem"]')?.classList.remove('focused');
    }}
  >
    {#snippet startIcon()}
      <Icon name={icon || 'edit_document'} />
    {/snippet}
  </TreeItem>
</div>

<style>
  .wrapper {
    display: contents;
  }
</style>
